module.exports = __webpack_public_path__ + "img/zanorari28.5bed6eae.jpg";